export var LogEvent;
(function (LogEvent) {
    LogEvent["INITIALIZE"] = "Initialize called";
    LogEvent["OPTED_OUT_GPC"] = "Browser GPC opted out";
    LogEvent["LOADED_OPT_OUT"] = "Loaded opt-out from cookie";
    LogEvent["LOADED_OPT_IN"] = "Loaded opt-in from cookie or no cookie";
    LogEvent["OPT_IN"] = "Opt-in selected";
    LogEvent["OPT_OUT"] = "Opt-out selected";
    LogEvent["DISPATCH_OPT_IN"] = "Opt-in dispatch called";
    LogEvent["DISPATCH_OPT_OUT"] = "Opt-out dispatch called";
    LogEvent["GPC_CHECK"] = "GPC check called";
    LogEvent["GET_CONSENT_STATE"] = "Get consent state called";
    LogEvent["LOG"] = "Log history retrieved";
    LogEvent["CUSTOM_EVENT_OPT_IN"] = "Opt-in event dispatched";
    LogEvent["CUSTOM_EVENT_OPT_OUT"] = "Opt-out event dispatched";
    LogEvent["COOKIE_READ_ERROR"] = "Cookie read failed";
    LogEvent["COOKIE_WRITE_ERROR"] = "Cookie write failed";
    LogEvent["LEGACY_COOKIE_MIGRATION"] = "Legacy cookie migration called";
    LogEvent["LEGACY_COOKIE_UPDATED_OPTED_IN"] = "Legacy cookie updated to opt-in";
    LogEvent["LEGACY_COOKIE_UPDATED_OPTED_OUT"] = "Legacy cookie updated to opt-out";
    LogEvent["LEGACY_COOKIE_CREATED_OPTED_IN"] = "Legacy cookie created with opt-in";
    LogEvent["LEGACY_COOKIE_CREATED_OPTED_OUT"] = "Legacy cookie created with opt-out";
})(LogEvent || (LogEvent = {}));
